module.exports = __webpack_public_path__ + "static/media/sendIcon.968317e5.svg";